import { PagedResultDto } from '@shared/components/paged-listing-component-base';
import { TrainingZoneTemplateDto } from './training-zone-template-dto';

export class TrainingZonePagedResultDto extends PagedResultDto {
    public items: TrainingZoneTemplateDto[] = [];
}
